module.exports = __webpack_public_path__ + "img/DE00646.f9d17d04.png";